import API from '@Modules/Authenticate/configs/api';
import apiMethod from '@utility/ApiMethod';

export const formSignUpCallMethod = ({ payload }) => {
  return apiMethod.post(API.AUTHENTICATE_SIGNUP, payload);
};
